import * as React from "react";

import { Button, TextArea } from "grommet";
import { useNavigate } from "react-router-dom";
import { normalizeColor } from "grommet/utils";
import Theme from "../utils/Theme";
import { useDarkMode } from "./DarkModeSwitch";

const AutoSizeTextArea = ({ value, onChange, disabled }: { value: any; onChange: Function; disabled: boolean }) => {
    const ref = React.useRef<HTMLTextAreaElement>(null);

    const resize = () => {
        if (ref.current) {
            ref.current.style.height = "inherit";
            ref.current.style.height = `${ref.current.scrollHeight + 10}px`;
        }
    };

    React.useEffect(() => {
        resize();
    }, [value]);

    const [isDarkMode, toggleDarkMode] = useDarkMode();

    return <TextArea ref={ref} value={value} onChange={(e) => onChange && onChange(e)} disabled={disabled} onKeyDown={resize} style={{ border: "none", backgroundColor: normalizeColor("background", Theme, isDarkMode) }} />;
};

export default AutoSizeTextArea;
